import { NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthorizationModule } from './components/authorization/authorization.module';
import { AuthorizeInterceptor } from './interceptors/authorize/authorize.interceptor';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { AppRoutingModule } from './app-routing.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CommonModule } from '@angular/common';
import { ApiUrlFixInterceptor } from './interceptors/api/api-url-fix.interceptor';
import { MatFormFieldModule } from '@angular/material/form-field';

import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-092537}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{LPG_Tank_Solutions_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{One-Tank_Dashboard}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{One-Tank_Dashboard}_need_to_be_licensed___{One-Tank_Dashboard}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{2_September_2026}____[v3]_[01]_MTc4ODMwMzYwMDAwMA==b5b5f15b57681ae61867a831dbbd22e1');

import { AgGridModule } from 'ag-grid-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImportWizardModule } from './components/dashboard/import-wizard/import-wizard.module';
import { ReleaseNotesDialogComponent } from './components/dashboard/release-notes/release-notes-dialog.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}


@NgModule({
  declarations: [
    AppComponent,
        DashboardComponent,
        ReleaseNotesDialogComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    AuthorizationModule,
    DashboardModule,
    MatFormFieldModule,
    AgGridModule,
    ImportWizardModule,
    NgbModule
  ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ApiUrlFixInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
